/**
 *  Layout uses for both client and server
 *
 * Server-side rendering means generating an HTML string, we are not rendering an actual “App”.
 * We want to get the App’s layout in markup form, hence <Layout />
 */

import { Component } from 'react'
import { ConnectedFlagsProvider } from 'flag'
import { Switch, Redirect } from 'react-router-dom'
import Helmet from 'react-helmet'
import RouteWithSubRoutes from '../lib/RouteWithSubRoutes'
import '@vzmi/shp_shared_compo/dist/index.css'

const SUPPLIER_TITLE = 'Yahoo供銷運籌管理'
const SELLER_TITLE = 'Yahoo Seller Dashboard'

class Layout extends Component {
  render () {
    const props = this.props
    const { routes, isSeller } = props

    return (
      <ConnectedFlagsProvider>
        <div>
          <Helmet
            titleTemplate={`%s - ${isSeller ? SELLER_TITLE : SUPPLIER_TITLE}`}
            defaultTitle={isSeller ? SELLER_TITLE : SUPPLIER_TITLE}
          />
          <Switch>
            {
              routes.map((route, i) => {
                return (
                  <RouteWithSubRoutes
                    key={i}
                    {...route}
                  />
                )
              })
            }
            {/* Redirect to error page if path doesn't match any of routes */}
            {isSeller && (
              <Redirect
                to={{
                  pathname: '/seller/error',
                  state: { errorMessage: '您的連結可能有誤，或您輸入的網址不存在！' }
                }}
              />
            )}
            {!isSeller && (
              <Redirect
                to={{
                  pathname: '/error',
                  search: '?code=404',
                  state: { errorMessage: '您的連結可能有誤，或您輸入的網址不存在！' }
                }}
              />
            )}
          </Switch>
        </div>
      </ConnectedFlagsProvider>
    )
  }
}

/** makes location, history can be accessable in Layout */
// const MappedLayout = withRouter(Layout)

export default Layout
